import React, { useEffect } from 'react';
import { FaChevronCircleRight } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getOrdersAction } from '../../actions';
import Layout from '../../components/Layout';
import { Breed } from '../../components/MaterialUI';
import Card from '../../components/UI/Card';
import Price from '../../components/UI/Price';
import Spinner from '../../components/UI/Spinner';
import { generatePublicUrl, shorten } from '../../HelperFunction';
import './style.css';

export default function OrderPage(props) {
	const dispatch = useDispatch();

	const user = useSelector((state) => state.user);
	// const orders = useSelector((state) => state.user.orders);

	useEffect(() => {
		document.title = 'Vos Commandes sur MimiShop';
		dispatch(getOrdersAction());
	}, []);

	// console.log(props.match);
	// console.log({ orders });

	// const renderOrders = () => {
	// 	if (user.orders.length > 0) {
	// 		return user.orders.map((order) =>
	// 			order.items.map((produc) => {
	// 				console.log(produc.productId.productPictures[0].img);
	// 				console.log(produc.productId.name);
	// 			})
	// 		);
	// 	} else {
	// 		return <h3 className="textCenter mt-5">Aucune Commande Disponible</h3>;
	// 	}
	// };

	if (!(user && user.orders)) {
		return <Layout><Spinner /></Layout>;
	}

	return (
		<Layout>
			<h3 className="textCenter m-5">Historique des Commandes</h3>
			<Breed
				breed={[
					{
						name: 'Accueil',
						href: '/'
					},
					{
						name: 'Mon Compte',
						href: '/account/'
					},
					{
						name: 'Mes Commandes',
						href: '/account/orders'
					}
				]}
				breedIcon={<FaChevronCircleRight />}
			/>
			{ user.orders.length ? user.orders.map((order) => {
				return order.items.map((produc, index) => (
					<Card key={produc._id} style={{ maxWidth: '1200px', display: 'block', margin: '40px auto' }}>
						<Link to={`/order_details/${order._id}`} className="orderItemContainer">
							<div className="orderImgContainer">
								<img
									className="orderImg"
									src={generatePublicUrl((produc.productId.productPictures[1] || produc.productId.productPictures[0])?.img)}
									alt={`image ${index}`}
								/>
							</div>

							<div className="orderProductName addPadding">{shorten(produc.productId.name, 60)}</div>

							{/* <div>Quantité: {}</div> */}
							<Price color="#007bff" title={`Facture: ${produc.purchasedQty}`} divider="x" value={produc.payablePrice} paddingTop="2rem" />

							<div className="addPadding">Status de Paiement: {order.paymentStatus}</div>
						</Link>
					</Card>
				));
			}) : <h3 className="textCenter m-5">Aucune Commande Disponible</h3>}
		</Layout>
	);
}
